"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function Create(_a) {
    var tokens = _a.tokens, setTokens = _a.setTokens, closeModal = _a.closeModal, setModal = _a.setModal;
    var _b = ra_fetch_1.useApi('auth')
        .records(setTokens, tokens)
        .store('tokens', {
        name: '',
    }), token = _b[0], setToken = _b[1], submitToken = _b[2];
    function onSubmit() {
        submitToken().then(function (response) {
            if (!response.errors.length) {
                setModal({
                    content: function () { return react_1.default.createElement(storybook_1.Forms.Success, { title: 'Persoonlijk API token opgeslagen!', subtitle: 'Kopieër direct je nieuwe persoonlijke API token. Het wordt voor jouw veiligheid niet meer getoond.', onClose: closeModal }); },
                });
            }
        });
    }
    return react_1.default.createElement(storybook_1.Forms.Form, null,
        react_1.default.createElement(storybook_1.Forms.Title, null, "Nieuwe persoonlijke API token"),
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Forms.Input, { value: token.data.name, type: 'text', placeholder: 'Naam', onChange: function (name) { return setToken({ name: name }); } })),
        react_1.default.createElement(storybook_1.Forms.Buttons, { errors: token.errors, loading: token.submitting, submit: onSubmit }));
}
function Token(_a) {
    var token = _a.token, tokens = _a.tokens, setTokens = _a.setTokens;
    var _b = ra_fetch_1.useApi('auth')
        .records(setTokens, tokens)
        .delete('tokens', { id: token.id }), deleteToken = _b[0], submitDeleteToken = _b[1];
    var Copy = storybook_1.Hooks.useCopy(token.token)[0];
    return react_1.default.createElement(storybook_1.Lists.Row, null,
        react_1.default.createElement(storybook_1.Lists.Column, { type: 'dt', colSpan: 3 },
            react_1.default.createElement("div", { className: 'flex justify-between items-center' },
                react_1.default.createElement(storybook_1.Texts.Primary, null, token.name),
                react_1.default.createElement("div", { className: 'w-3/4' }, token.token && react_1.default.createElement(Copy, null)),
                react_1.default.createElement(storybook_1.Buttons.Button, { icon: 'trash', onClick: submitDeleteToken }))));
}
function Tokens(_a) {
    var setModal = _a.setModal, closeModal = _a.closeModal;
    var _b = ra_fetch_1.useApi('auth').index('tokens'), tokens = _b[0], setTokens = _b[1];
    if (tokens.loading) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_1.default.createElement(storybook_1.Cards.Card, null,
        react_1.default.createElement(storybook_1.Lists.Header, null,
            react_1.default.createElement("div", { className: 'flex justify-between items-center' },
                react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3' }, "Mijn persoonlijke API tokens"),
                react_1.default.createElement(storybook_1.Buttons.Button, { type: 'primary', onClick: function () { return setModal({
                        content: function () { return react_1.default.createElement(Create, { setModal: setModal, closeModal: closeModal, tokens: tokens.data, setTokens: setTokens }); },
                    }); } }, "Aanmaken"))),
        react_1.default.createElement(storybook_1.Lists.List, null, tokens.data.map(function (token, index) { return react_1.default.createElement(Token, { token: token, key: index, tokens: tokens.data, setTokens: setTokens }); })));
}
exports.default = Tokens;
